import React, { useContext } from "react";
import { DialogContent } from "./Dialog";

export interface DialogProps {
    pushError: (message:DialogContent) => void;
    pushInfo: (message: DialogContent) => void; 
}

const defaultDialogProps: DialogProps = {
    pushError: (message: DialogContent) => {},
    pushInfo: (message: DialogContent) => {}
}

export const DialogContext = React.createContext<DialogProps>(defaultDialogProps);

export const useDialog = () => {
    return useContext(DialogContext);
}